import { render, staticRenderFns } from "./ownLogisticsChannelModal.vue?vue&type=template&id=c8d1a82c&scoped=true"
import script from "./ownLogisticsChannelModal.vue?vue&type=script&lang=js"
export * from "./ownLogisticsChannelModal.vue?vue&type=script&lang=js"
import style0 from "./ownLogisticsChannelModal.vue?vue&type=style&index=0&id=c8d1a82c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d1a82c",
  null
  
)

export default component.exports